
import { defineComponent } from 'vue';
import 'bootstrap';

export default defineComponent({
    setup() {
        //console.log('App.setup(), Starting...');
        return {};
    }
});
